import { push } from 'utils/common.util';
import request from 'services/request';
import * as api from 'routes/profile.routes';
import {
  DeleteSessionUrl,
  PurchasedPackagesUrl,
  ActiveSessionUrl,
  ProfileTransactionHistoryUrl,
  CreateInvoiceUrl,
  ProfileInformationUrl,
} from 'routes/profile.routes';
import { ProductsRoute } from 'routes/product.routes';
import { checkExpiration } from 'utils/permission.util';
import useWalletStore from 'store/wallet';

export const getPurchasedPackageDataAction = async (set): Promise<void> => {
  set(() => ({
    purchasedPackageData: null,
  }));
  const { getProductsDataAction } = useWalletStore.getState();

  const response = await request.get(PurchasedPackagesUrl());
  const productsList = await getProductsDataAction();

  if (response.ok) {
    const expirePackages = checkExpiration(
      response.data.data.purchased_packages,
      productsList,
    );
    set(() => ({
      purchasedPackageData: { ...response?.data?.data, expirePackages },
    }));
  }
};

export const getActiveSessionsAction = async (set): Promise<void> => {
  set(() => ({
    activeSessions: null,
    activeSessionsLoading: true,
    activeSessionsError: false,
  }));

  const response = await request.get(ActiveSessionUrl());
  const responseData = response?.data.data;
  set(() => ({
    activeSessions: response.ok ? responseData : null,
    activeSessionsError: !response.ok,
    activeSessionsLoading: false,
  }));
};

// todo: handle loading after backend got fixed
export const deleteActiveSessionsAction = async (
  set,
  id: string,
): Promise<void> => {
  const response = await request.delete(DeleteSessionUrl(id));
  response.ok && (await getActiveSessionsAction(set));
};

export const getTransactionHistoryAction = async (set): Promise<void> => {
  set(() => ({
    transactionHistoryLoading: true,
    transactionHistoryError: false,
  }));
  const response = await request.get(ProfileTransactionHistoryUrl());
  const responseData = response.data?.data?.results;
  set(() => ({
    transactionsHistoryData: response.ok ? responseData : [],
    transactionHistoryError: !response.ok,
    transactionHistoryLoading: false,
  }));
};

export const createInvoiceAction = async (set, id: string): Promise<void> => {
  set(() => ({
    createInvoiceLoading: true,
    createInvoiceError: false,
  }));
  const response = await request.get(CreateInvoiceUrl(id));
  response.ok
    ? await getTransactionHistoryAction(set)
    : set(() => ({
        createInvoiceError: true,
      }));
};

export const getProfileInformationAction = async (set): Promise<void> => {
  set(() => ({
    profileInformationError: false,
  }));

  const response = await request.get(ProfileInformationUrl());

  const responseData = response.data?.data;
  set(() => ({
    profileInformation: response.ok
      ? {
          ...responseData.profile,
          phone_number: responseData.phone_number,
          hasPassword: responseData.has_password,
        }
      : null,
    profileInformationError: !response.ok,
  }));
};

export const setProfileInformationAction = async (
  set,
  data,
): Promise<boolean> => {
  set(() => ({
    saveProfileInformationLoading: true,
  }));

  const response = await request.post(ProfileInformationUrl(), data);

  set(() => ({
    saveProfileInformationLoading: false,
  }));
  // the business logic wants to return to prev page if user saved the profile information,
  // therefore, we should pass the response of set the data, and check in component to if the response is true, call the back function.
  return response.ok;
};

export const changePasswordAction = async (set, body): Promise<boolean> => {
  set({ changePasswordLoading: true, changePasswordError: false });
  const response = await request.put(api.ChangePasswordUrl(), body);
  if (response.ok) {
    set({ changePasswordLoading: false });
  } else set({ changePasswordLoading: false, changePasswordError: true });
  return response.ok;
};

export const createPasswordAction = async (set, body): Promise<void> => {
  set({ createPasswordLoading: true, createPasswordError: false });
  const res = await request.post(api.CreatePasswordUrl(), body);
  set({ createPasswordLoading: false, createPasswordError: res.ok });
  res.ok && push(ProductsRoute())();
};
